<template>
    <div id="star-select-input">
        <span v-for="star in stars"
            type="radio"
            :id="`star-${star}`"
            :key="`star-${star}`"
            name="star-select-radio"
            class="star"
            @mouseenter="hover_star(star)"
            @mouseleave="hover_star(null)"
            @click="select_star(star)"
        >
            {{ star_template(star) }}
        </span>
    </div>
</template>

<script>
export default {
    props: {
        value: {
            type: Number,
            default: null
        },
        stars: {
            type: Number,
            default: 5
        }
    },
    data() {
        return {
            hoveredStar: null,
        }
    },
    methods: {
        star_template(star) {
            if (this.hoveredStar != null && star <= this.hoveredStar)
                return "★"
            else if (this.hoveredStar === null && this.value != null && star <= this.value)
                return "★"
            else
                return "☆"
        },
        select_star(star) {
            this.$emit('input', star)
        },
        hover_star(star) {
            this.hoveredStar = star
        }
    }
}
</script>

<style lang="scss" scoped>
#star-select-input {
    display: flex;

    span.star {
        font-size: 24pt;
        color: goldenrod;
        cursor: pointer;
        flex: 1;
    }
}
</style>